var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartrateMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.89543 2 3 2.89543 3 4V18C3 19.1046 3.89543 20 5 20V21C5 21.5523 5.44772 22 6 22H8C8.55228 22 9 21.5523 9 21V20H15V21C15 21.5523 15.4477 22 16 22H18C18.5523 22 19 21.5523 19 21V20C20.1046 20 21 19.1046 21 18V4C21 2.89543 20.1046 2 19 2H5ZM5 3H19C19.5523 3 20 3.44772 20 4V8.25H16.7631L14.4685 6.41435C14.2995 6.27915 14.0804 6.22354 13.8673 6.26183C13.6543 6.30011 13.4682 6.42854 13.3569 6.61413L10.8511 10.7904L8.53033 8.46967C8.38968 8.32902 8.19891 8.25 8 8.25H4V4C4 3.44772 4.44772 3 5 3ZM4 15V9.75H7.68934L10.4697 12.5303C10.633 12.6936 10.8624 12.7726 11.0916 12.7444C11.3209 12.7162 11.5243 12.5839 11.6431 12.3859L14.2016 8.12175L16.0315 9.58565C16.1645 9.69204 16.3297 9.75 16.5 9.75H20V15C20 15.5523 19.5523 16 19 16H5C4.44772 16 4 15.5523 4 15ZM6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18C7 18.5523 6.55228 19 6 19ZM10 18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartrateMonitor);
export default __webpack_public_path__ + "static/media/heartrate-monitor.b811e2cc11f6f3f9f3733db4037d9b8a.svg";
export { ForwardRef as ReactComponent };